import { createFileRoute } from '@tanstack/react-router';
import dayjs from 'dayjs';
import { Divider } from '@heroui/react';
import DemoPlug from '@/components/blog/[slug]/DemoPlug';
import Post from '@/posts/what-is-strokes-gained.mdx';
import { ReactNode } from 'react';

const components: { [x: string]: (props: { [x: string]: string | number | unknown }) => ReactNode } = {
    h1: props => <h1 className='my-4 text-4xl font-semibold' {...props} />,
    h2: props => <h2 className='my-3 text-3xl font-semibold' {...props} />,
    h3: props => <h2 className='my-3 text-2xl font-semibold' {...props} />,
    h4: props => <h2 className='my-3 text-2xl font-semibold' {...props} />,
    h5: props => <h2 className='my-3 text-2xl font-semibold' {...props} />,
    p: props => <p className='my-4' {...props} />,
    a: props => {
        return (
            <a
                className='text-blue-600 hover:underline'
                target='_blank'
                rel='noopener noreferrer'
                {...props}
            />
        );
    },
};

export const Route = createFileRoute('/blog/what-is-strokes-gained')({
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <article className='prose lg:prose-xl mx-auto px-4'>
            <h1 className='my-3 text-center text-4xl font-bold'>What Is Strokes Gained?</h1>
            <div className='text-center text-sm'>{dayjs('2026-01-01').format('MMM D, YYYY')}</div>
            <div className='mx-auto max-w-4xl'>
                <Post components={components} />
                <Divider className='mb-4' />
                <DemoPlug />
            </div>
        </article>
    );
}
